import React from 'react';
const Blog = () => {
    return (
        <div className='pb-24 mb-48 '>
            <h1 className='text-center my-4 text-4xl font-bold bg-secondary my-0 text-white py-4'>Blog </h1>

            <h1 className='text-4xl font-bold my-16 flex justify-center '>Comming Soon...</h1>
            
        </div>
    );
};

export default Blog;